import Layout from '@/apps/accounts/index'
import ListPage from '@/apps/accounts/views/List'
export default {
  path: 'accounts',
  name: 'Accounts',
  component: ListPage,
  children: [{ path: 'list', name: 'Accounts.List', component: ListPage }]
}



// WEBPACK FOOTER //
// ./src/apps/accounts/routes/index.js